<template>
        <div class="phone-input-wrapper">
            <span v-show="required" class="required-indicator">*</span>
            <span v-if="required && showError" class="icon-input-error"></span>
            <vue-phone-number-input v-bind:value="value" 
                                    v-on:update="(val) => $emit('update', val)" 
                                    v-on:input="(val) => $emit('input', val)" 
                                    :default-country-code="defaultCountryCode"
                                    :class="{ 'filled': hasValue, 'error': required && showError }"
                                    v-on:phone-number-focused="() => $emit('focus')"></vue-phone-number-input>
            <label v-if="required && showError" class="error-text">{{ errorMessage }}</label>
        </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
export default {
  components: {
      'vue-phone-number-input': VuePhoneNumberInput,
  },
  props: {
    label: String,
    value: [Number, String],
    showError: Boolean,
    defaultCountryCode: String,
    errorMessage: String,
    required: Boolean,
  },
};
</script>

<style>
    .phone-input-wrapper .input-tel__input {
        left: 1.5px;
        font-family: "proxima-nova";
        color: #6A7992 !important;
        font-size: 16px !important;
        font-weight: 300 !important;
    }

    .phone-input-wrapper,
    .phone-input-wrapper .country-selector__input,
    .phone-input-wrapper .country-selector,
    .phone-input-wrapper .input-tel__input {
        height: 50px !important;
        min-height: 50px !important;
        border-color: #54c08a !important;
    }

    .phone-input-wrapper .input-tel__label,
    .phone-input-wrapper .country-selector__label{
        padding-top: 2px;
        color: #54c08a !important;
        font-size: 10px !important;
        font-family: 'proxima-nova' !important;
        font-weight: 300 !important;
        text-transform: uppercase;
    }

    .phone-input-wrapper .country-selector__country-flag{
        top: 25px !important;
    }

    .input-tel__input input::placeholder {
        color: #97a8b6;
        font-size: 16px !important;
        font-family: "proxima-nova" !important;
    }

    .input-tel__input.filled {
        border: 1px solid #54c08a !important;
        background-color: white !important;
        border-radius: 4px;
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .phone-input-wrapper .vue-phone-number-input.error {
        border: 1px solid #54c08a !important;
        border-radius: 5px;
    }

    .phone-input-wrapper .icon-input-error {
        font-size: 20px !important;
        color: #ee653b;
        z-index: 10;
        position: absolute;
        top: 17px;
        display: block;
        right: 36px;
    }

    .phone-input-wrapper .required-indicator {
        color: #ee653b;
        position: absolute;
        right: 23px;
        top: -3px;
        z-index: 1;
        font-size: 24px;
    }

    .phone-input-wrapper .input-phone-number.is-focused {
        z-index: 0 !important;
    }

    .phone-input-wrapper .input-tel__input:focus-within,
    .phone-input-wrapper .input-tel__input:hover,
    .phone-input-wrapper .input-country-selector:hover .country-selector__input,
    .phone-input-wrapper .country-selector__input:focus-within {
        border: 1px solid #54c08a !important;
        box-shadow: unset !important;
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .country-selector__input {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .phone-input-wrapper .input-tel__input .vti__input {
        background-color: white !important;
        border: 1px solid #54c08a !important;
    }

    .error-text {
        color: #ee653b;
        font-family: "proxima-nova";
        font-size: 12px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// vPhoneInput.vue?47ff35c5